import React, { Component } from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@shadcn/components/ui/dropdown-menu';

//i18n
import i18n from '../../../i18n';
import { withNamespaces } from 'react-i18next';

// falgs
import usFlag from "../../../assets/images/flags/us.jpg";
import spain from "../../../assets/images/flags/spain.jpg";
import germany from "../../../assets/images/flags/germany.jpg";
import italy from "../../../assets/images/flags/italy.jpg";
import russia from "../../../assets/images/flags/russia.jpg";

class LanguageDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      lng : "English",
      flag : usFlag
    };
    this.toggle = this.toggle.bind(this);
    this.changeLanguageAction = this.changeLanguageAction.bind(this);
  }

  changeLanguageAction = (lng) => {

     //set language as i18n
     i18n.changeLanguage(lng);

    if(lng === "sp")
        this.setState({lng : "Spanish", flag : spain });
    else if(lng === "gr")
        this.setState({lng : "German", flag : germany });
    else if(lng === "rs")
        this.setState({lng : "Russian", flag : russia });
    else if(lng === "it")
        this.setState({lng : "Italian", flag : italy });
    else if(lng === "eng")
        this.setState({lng : "English", flag : usFlag });
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu
    }));
  }

  render() {

    return (
      <React.Fragment>

        <DropdownMenu>
          <DropdownMenuTrigger
            href="#"
            className="card-drop"
            tag="i"
            onClick={this.toggleMenu}
          >
            <img
              src={this.state.flag}
              alt="Flag"
              height="16"
              className="mr-1"
            />
            <span className="align-middle">{this.state.lng}</span>
          </DropdownMenuTrigger>
          <DropdownMenuContent right>
            <DropdownMenuItem
              onClick={() => this.changeLanguageAction('eng')}
              className={`notify-item ${this.state.lng === 'eng' ? 'active' : ''}`}
            >
              <img src={usFlag} alt="English" className="mr-1" height="12" />
              <span className="align-middle">English</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => this.changeLanguageAction('sp')}
              className={`notify-item ${this.state.lng === 'sp' ? 'active' : ''}`}
            >
              <img src={spain} alt="Spanish" className="mr-1" height="12" />
              <span className="align-middle">Spanish</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => this.changeLanguageAction('gr')}
              className={`notify-item ${this.state.lng === 'gr' ? 'active' : ''}`}
            >
              <img src={germany} alt="German" className="mr-1" height="12" />
              <span className="align-middle">German</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => this.changeLanguageAction('it')}
              className={`notify-item ${this.state.lng === 'it' ? 'active' : ''}`}
            >
              <img src={italy} alt="Italian" className="mr-1" height="12" />
              <span className="align-middle">Italian</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => this.changeLanguageAction('rs')}
              className={`notify-item ${this.state.lng === 'rs' ? 'active' : ''}`}
            >
              <img src={russia} alt="Russian" className="mr-1" height="12" />
              <span className="align-middle">Russian</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </React.Fragment>
    );
  }
}

export default withNamespaces()(LanguageDropdown);
